export const CHAT_EVENTS = {
  // Outgoing
  GET_CHAT_LIST: 'chat-list',
  GET_MSG_LIST: 'msg-list',
  SEND_MSG: 'send-msg',
  FIND_ITEM: 'get-item-stock',
  READ_MSG: 'read-msg',
  TYPING_START: 'typing-start',
  TYPING_STOP: 'typing-stop',
  LEAVE_CHAT: 'leave-chat',
  SINGLE_CHAT: 'single-chat',
  RECEIVE_READ_MSG: 'read-msg',

  // Incoming
  RECEIVE_MSG: 'receive-msg',
  CHAT_LIST_DATA: 'chat-list', // Assuming same event name for response? Or usually they are different. In SocketContext it uses 'chatList' for both emit and on.
  MSG_LIST_DATA: 'msg-list',
};
